(() => {
"use strict";
// Feedback page: registration stays disabled until its integration is approved.
const menu = document.querySelector('#mobile-menu');
const menuButton = document.querySelector('.menu-toggle');
const closeMenu = () => {
  menu.close();
  document.body.classList.remove('menu-open');
  menuButton.setAttribute('aria-expanded', 'false');
};
menuButton.addEventListener('click', () => {
  menu.showModal();
  document.body.classList.add('menu-open');
  menuButton.setAttribute('aria-expanded', 'true');
});
document.querySelector('.close-menu').addEventListener('click', closeMenu);
menu.addEventListener('close', () => {
  document.body.classList.remove('menu-open');
  menuButton.setAttribute('aria-expanded', 'false');
});
menu.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
menu.addEventListener('click', e => {
  const box = menu.getBoundingClientRect();
  if (e.target === menu && (e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom)) closeMenu();
});
window.matchMedia('(min-width: 1100px)').addEventListener('change', e => { if (e.matches && menu.open) closeMenu(); });

const form = document.querySelector('#event-form');
if (form) form.addEventListener('submit', event => event.preventDefault());

// Formularul Shopify Forms (inline, ID 1165502) se randează într-un shadow DOM; aliniem stilul la pagină.
const formsHost = document.querySelector('[data-forms-id="forms-root-1165502"]');
const formsCSS = `:host{--button-background-color:#1c1c1c!important;--button-text-color:#fff!important;--button-border:1px solid #1c1c1c!important;--button-border-radius:0!important;--forms-body-font:"Nunito Sans",sans-serif!important;--forms-accent-color:#1c1c1c!important;--form-field-border-radius:0!important;--form-field-border:1px solid #a9a7a1!important;--container-background-color:transparent!important;--form-background-color:transparent!important;--container-shadow:none!important;--container-text-alignment:left!important;--inline-form-alignment:left!important;--forms-base-font-size:16px!important;--heading-text-color:#1c1c1c!important;--body-text-color:#62605d!important;--forms-padding-left:0!important;--forms-padding-right:0!important;--forms-padding-top:0!important;--forms-padding-bottom:0!important;--spacing-size-x:0!important;--inline-container-max-width:100%!important}
h1,h2,h3{font-family:Montserrat,sans-serif!important;text-transform:uppercase;letter-spacing:-.03em;text-align:left!important}
h2{display:none!important} h2+*{display:none!important}
p,label,input,button,div{font-family:"Nunito Sans",sans-serif!important}
form{gap:14px}
button[type=submit],button[class*=formSubmitButton]{background:#1c1c1c!important;color:#fff!important;border:1px solid #1c1c1c!important;border-radius:0!important;min-height:52px;width:100%;max-width:100%;box-sizing:border-box;padding:14px 16px;line-height:1.3;text-transform:uppercase;font-size:14px;letter-spacing:0}
input{border-radius:0!important;min-height:54px;background:#fff!important;font-size:16px!important}`;
function styleFormsEmbed() {
  const embed = formsHost && formsHost.querySelector('shopify-forms-embed');
  if (!embed || !embed.shadowRoot || embed.dataset.bluzatStyled) return false;
  const root = embed.shadowRoot;
  try {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(formsCSS);
    root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
  } catch (error) {
    const style = document.createElement('style');
    style.textContent = formsCSS;
    root.appendChild(style);
  }
  embed.dataset.bluzatStyled = '1';
  return true;
}
if (formsHost) {
  if (!styleFormsEmbed()) {
    const formsObserver = new MutationObserver(() => { if (styleFormsEmbed()) formsObserver.disconnect(); });
    formsObserver.observe(formsHost, { childList: true, subtree: true });
  }
}


const sticky = document.querySelector('#mobile-cta');
const heroCTA = document.querySelector('#hero-cta');
const registration = document.querySelector('#inscriere');
function updateSticky() {
  const viewport = window.visualViewport;
  const viewportHeight = viewport ? viewport.height : window.innerHeight;
  const heroBox = heroCTA.getBoundingClientRect();
  const formBox = registration.getBoundingClientRect();
  const passedHero = heroBox.bottom < 0;
  const registrationVisible = formBox.top < viewportHeight && formBox.bottom > 0;
  const editing = document.activeElement?.matches('input, textarea, select');
  const keyboardOpen = viewport && window.innerHeight - viewport.height > 120;
  sticky.hidden = window.innerWidth >= 700 || !passedHero || registrationVisible || editing || keyboardOpen;
}
const stickyObserver = new IntersectionObserver(updateSticky, { threshold: [0, .1, 1] });
stickyObserver.observe(heroCTA);
stickyObserver.observe(registration);
window.addEventListener('scroll', updateSticky, { passive: true });
window.addEventListener('resize', updateSticky, { passive: true });
window.visualViewport?.addEventListener('resize', updateSticky, { passive: true });
document.addEventListener('focusin', updateSticky);
document.addEventListener('focusout', () => requestAnimationFrame(updateSticky));
updateSticky();

// Ambient films load near the viewport. User pause and reduced motion take precedence.
const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
const dataSaver = navigator.connection?.saveData === true;
const films = [...document.querySelectorAll('.ambient-film')];
const filmState = new Map();
const filmButtons = new Map();
films.forEach(video => {
  const button = document.querySelector(`[data-video="${video.id}"]`);
  const state = { visible: false, pausedByUser: false, explicitlyPlayed: false, failed: false };
  filmState.set(video, state);
  filmButtons.set(video, button);
  button.hidden = false;
  const updateControl = () => {
    const playing = !video.paused;
    button.classList.toggle('is-playing', playing);
    button.querySelector('.motion-label').textContent = state.failed ? 'Indisponibil' : playing ? 'Pauză' : 'Redă';
    button.setAttribute('aria-label', `${playing ? 'Pune pe pauză' : 'Redă'} videoclipul: ${video.getAttribute('aria-label')}`);
  };
  video.addEventListener('play', updateControl);
  video.addEventListener('pause', updateControl);
  video.addEventListener('error', () => {
    state.failed = true;
    video.pause();
    button.disabled = true;
    updateControl();
  });
  button.addEventListener('click', () => {
    if (!video.paused) {
      state.pausedByUser = true;
      video.pause();
    } else {
      state.pausedByUser = false;
      state.explicitlyPlayed = true;
      startFilm(video);
    }
  });
});
function startFilm(video) {
  const state = filmState.get(video);
  if (state.failed || document.hidden) return;
  if (!video.getAttribute('src')) {
    video.src = window.innerWidth < 700 && video.dataset.mobileSrc ? video.dataset.mobileSrc : video.dataset.src;
    video.load();
  }
  video.muted = true;
  video.play().catch(() => { /* The poster and play control remain available if autoplay is blocked. */ });
}
function reconcileFilm(video) {
  const state = filmState.get(video);
  if (!state.visible || document.hidden || state.pausedByUser || (motionPreference.matches || dataSaver) && !state.explicitlyPlayed) {
    video.pause();
  } else {
    startFilm(video);
  }
}
const filmObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    filmState.get(entry.target).visible = entry.isIntersecting && entry.intersectionRatio >= .2;
    reconcileFilm(entry.target);
  });
}, { threshold: [0, .2, .5] });
films.forEach(video => filmObserver.observe(video));
document.addEventListener('visibilitychange', () => films.forEach(reconcileFilm));
motionPreference.addEventListener('change', () => {
  films.forEach(video => {
    filmState.get(video).explicitlyPlayed = false;
    reconcileFilm(video);
  });
});

// Native, touch-friendly horizontal gallery. No automatic slide changes.
const looksTrack = document.querySelector('#looks-track');
const looks = [...looksTrack.querySelectorAll('.look-slide')];
const previousLook = document.querySelector('#looks-prev');
const nextLook = document.querySelector('#looks-next');
const looksCounter = document.querySelector('#looks-counter');
document.querySelector('.slider-controls').hidden = false;
let activeLook = 0;
function lookStep() {
  return looks[0].getBoundingClientRect().width + parseFloat(getComputedStyle(looksTrack).columnGap);
}
function updateLooks() {
  const max = looksTrack.scrollWidth - looksTrack.clientWidth;
  const trackStyle = getComputedStyle(looksTrack);
  const gap = parseFloat(trackStyle.columnGap);
  const available = looksTrack.clientWidth - parseFloat(trackStyle.paddingLeft) - parseFloat(trackStyle.paddingRight);
  const visibleLooks = Math.max(1, Math.floor((available + gap + 1) / lookStep()));
  activeLook = Math.min(looks.length - 1, Math.round(looksTrack.scrollLeft / lookStep()));
  const first = String(activeLook + 1).padStart(2, '0');
  const last = String(Math.min(looks.length, activeLook + visibleLooks)).padStart(2, '0');
  looksCounter.textContent = `${visibleLooks > 1 ? `${first}–${last}` : first} / ${String(looks.length).padStart(2, '0')}`;
  previousLook.disabled = looksTrack.scrollLeft < 3;
  nextLook.disabled = looksTrack.scrollLeft >= max - 3;
}
function moveLook(direction) {
  looksTrack.scrollBy({ left: direction * lookStep(), behavior: motionPreference.matches ? 'auto' : 'smooth' });
}
previousLook.addEventListener('click', () => moveLook(-1));
nextLook.addEventListener('click', () => moveLook(1));
looksTrack.addEventListener('keydown', event => {
  if (event.target !== looksTrack) return;
  if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
    event.preventDefault();
    moveLook(event.key === 'ArrowRight' ? 1 : -1);
  }
});
let galleryFrame;
looksTrack.addEventListener('scroll', () => {
  cancelAnimationFrame(galleryFrame);
  galleryFrame = requestAnimationFrame(updateLooks);
}, { passive: true });
window.addEventListener('resize', () => {
  const target = Math.min(activeLook * lookStep(), looksTrack.scrollWidth - looksTrack.clientWidth);
  looksTrack.scrollTo({ left: target, behavior: 'instant' });
  updateLooks();
}, { passive: true });
updateLooks();

})();
